import "../styles/footer.css";
import {
  TbMail,
  TbPhoneCall,
  TbBrandSkype,
  TbBrandDiscord,
  TbBrandGithub,
} from "react-icons/tb";

const Footer = () => {
  return (
    <footer>
      <form className="contact">
        <h1>Contact Information</h1>
        <div className="input-field">
          <TbMail />
          <input
            type="email"
            placeholder="Your email"
            value="johnlee98713@gmail.com"
            readOnly
          />
        </div>
        <div className="input-field">
          <TbBrandGithub />
          <input
            type="text"
            placeholder="Your Github Account"
            value="https://github.com/johnlee713"
            readOnly
          />
        </div>
        <div className="input-field">
          <TbPhoneCall />
          <input
            type="text"
            placeholder="Your Phone Number"
            value="+1 573 287 3792"
            readOnly
          />
        </div>
        <div className="input-field">
          <TbBrandDiscord />
          <input
            type="text"
            placeholder="Your Discord Name"
            value="John Li#9042"
            readOnly
          />
        </div>
        <div className="input-field">
          <TbBrandSkype />
          <input
            type="text"
            placeholder="Your Skype Name"
            value="live:.cid.447cb2e1ffa5c3c7"
            readOnly
          />
        </div>
      </form>
    </footer>
  );
};

export default Footer;
